















































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { konsulRanapStore } from "@/store/modules/SuratKonsulRanapStore";
import moment from "moment";
import { userModule } from "@/store/modules/user";
import http from "@/axios/http-common";
import ModalDetailKonsul from "@/components/modal/CardModalDetailKonsul.vue";
import InputKonsulRanapModal from "@/components/modal/InputKonsulRanapModal.vue";
import CardModalJawabKonsul from "@/components/modal/CardModalJawabKonsul.vue";
import { storePasien } from "@/store/modules/pasien";
import { storeSoap } from "@/store/modules/soap";
import { appModule } from "@/store/modules/app";
import CardModalAlasanBatalOrder from "@/components/modal/CardModalAlasanBatalOrder.vue";
import DataKonsul from "@/services/DataKonsul";
import { confirmRemove } from "@/utility/CommonHelper";
import SuratKonsul from "@/services/new/SuratKonsul";

@Component({
  components: {
    ModalDetailKonsul,
    InputKonsulRanapModal,
    CardModalJawabKonsul,
    CardModalAlasanBatalOrder
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class ListKonsulPasien extends Vue {
  @Prop() register!: string;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  modalOpen = false;
  modalOpenKonsul = false;
  modalJawabKonsul = false;
  dataKonsul = null;
  jwbKonsul = null;
  idKonsul = null;
  modalBatalKonsul = false;

  mounted() {
    this.loadKonsulList();
  }

  get stateUser() {
    return userModule.user;
  }

  get headers() {
    const headers = [
      {
        text: "Tgl/ Dokter Pengirim",
        value: "tgl_kirim",
        align: "left",
        width: "20%"
      },
      { text: "Diagnosa", value: "diagnosis", align: "left", width: "4vh" },
      { text: "Masalah", value: "masalah", align: "left", width: "4vh" },
      {
        text: "Konsultasi yg Diminta",
        value: "konsultasi",
        align: "left",
        width: "4vh"
      },
      {
        text: "Dokter Konsulan",
        value: "dokter_tujuan",
        align: "left",
        width: "4vh"
      },
      {
        text: "Jawaban",
        value: "jawaban",
        align: "left",
        width: "4vh"
      },
      { text: "Aksi", value: "id", align: "left", width: "5%" }
    ];

    return headers;
  }

  get loadingList() {
    return konsulRanapStore.loading;
  }

  get listKonsul() {
    return konsulRanapStore.listOnReg;
  }

  get pasien() {
    return storePasien.identitasPasien;
  }

  get canMakeKonsul() {
    if (this.readOnly) return false;
    return this.stateUser.profesi == "Dokter";
  }

  get soapList() {
    return storeSoap.detailSoap;
  }

  showKonsul() {
    // console.log("should show konsul....");
    // this.modalOpen = true;
  }

  getHumanDate(date) {
    return date ? moment(date, "YYYY-MM-DD").format("DD MMMM YYYY") : "";
  }

  print(id) {
    const routeData = http.getAPI() + "/surat-konsul/" + id + "/pdf";
    window.open(routeData, "_blank");
  }

  terima(item) {
    SuratKonsul.terimaByRanap(item.id, {
      unit_penerima_id: userModule.user.unit_id,
      dokter_penerima_id: userModule.user.id
    }).then(resp => {
      if (resp.data) {
        appModule.NoticeDelay(resp.data.message);

        this.loadKonsulList();
      }
    });
  }

  detailKonsul() {
    console.log("detail konsul....");
  }

  ubahKonsul(val) {
    this.dataKonsul = val;
    this.modalOpenKonsul = true;
  }

  jawabKonsul(val) {
    this.jwbKonsul = {
      pasien: this.pasien,
      register: this.register,
      suratKonsul: val
    };
    this.modalJawabKonsul = true;
  }

  ubahJawabKonsul(val) {
    this.jwbKonsul = {
      pasien: this.pasien,
      register: this.register,
      suratKonsul: val
    };
    // konsulRanapStore.actKonsul_on_reg(this.register);
    this.modalJawabKonsul = true;
  }

  closePanel() {
    this.loadKonsulList();
  }

  showModalCreateKonsul() {
    if (this.canMakeKonsul) {
      this.dataKonsul = null;
      this.modalOpenKonsul = true;
    } else {
      appModule.sendErrorAlert(
        "Mohon isi Catatan SOAP terlebih dahulu sebelum membuat Surat Rujukan Internal"
      );
    }
  }

  showModalBatal(value) {
    this.idKonsul = value;
    this.modalBatalKonsul = true;
  }

  removeKonsul(val) {
    const dt = DataKonsul.batalDataKonsul(val["id"], val["alasan"]);
    dt.then(dt => {
      appModule.setLoading(false);
      // if (dt.data.status == 1) {
      if (dt["data"]["status"] == 1) {
        konsulRanapStore.getListKonsulByRegister(parseInt(this.register));
        appModule.NoticeDelay("Berhasil Membatalkan Surat Konsul");
      }
    });
  }

  cancelTerima(id) {
    const conf = confirmRemove(
      "Pasien Konsul",
      "Anda yakin batal menerima konsulan pasien ini?"
    );

    if (conf) {
      DataKonsul.cancelTerimaKonsul(id).then(resp => {
        appModule.NoticeDelay(resp.message);

        this.loadKonsulList();
      });
    }
  }

  loadKonsulList() {
    konsulRanapStore.getListKonsulByRegister(parseInt(this.register));
  }

  @Watch("modalOpenKonsul")
  changeModalOpenKonsul(val) {
    if (!val) {
      this.dataKonsul = null;
    }
  }

  checkIsCanReply(item) {
    if (this.readOnly) return false;
    return (
      !item.jawaban &&
      item.dokter_tujuan &&
      item.dokter_tujuan.id == this.stateUser.id
    );
  }

  checkIsCanEditReply(item) {
    if (this.readOnly) return false;
    return (
      item.jawaban &&
      item.dokter_tujuan &&
      item.dokter_tujuan.id == this.stateUser.id
    );
  }

  checkIsCanAccept(item) {
    if (this.readOnly) return false;
    return (
      !item.accepted_at &&
      item.dokter_pengirim.id != this.stateUser.id &&
      item.dokter_tujuan.id == this.stateUser.id
    );
  }
}
